import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

type Props = {
  children?: ReactNode;
  className?: string;
};

export default function SectionCard({ children, className }: Props) {
  return (
    <div
      className={cn(
        'dark:bg-theme-slate-800 border dark:border-theme-gray-700 p-6 rounded-2xl w-full mx-auto',
        className,
      )}
    >
      {children}
    </div>
  );
}

const Title = ({ children, className }: Props) => (
  <div
    className={cn(
      'justify-start text-white text-2xl font-bold capitalize  mb-6',
      className,
    )}
  >
    {children}
  </div>
);

const Content = ({ children, className }: Props) => (
  <div
    className={cn(
      'space-y-5 max-h-[360px] overflow-y-auto pr-2 custom-scroll',
      className,
    )}
  >
    {children}
  </div>
);

SectionCard.displayName = SectionCard;
SectionCard.Title = Title;
SectionCard.Content = Content;
